export const FIELDS = {
  TITLE: 'title',
  CONTENT: 'content',
};
